// import { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { TruckIcon, BoltIcon, WrenchIcon, GearIcon, CrystalIcon, AtomIcon, ShieldIcon } from "../Icons";

// const steps = [
//   {
//     num: "01",
//     iconName: "truck",
//     title: "Collection & Intake",
//     tagline: "Safe pickup. Full documentation.",
//     body: "Batteries are collected from OEM facilities, dealer networks, and scrap aggregators across India. Every consignment is weighed, catalogued by chemistry and condition, and issued an intake document before entering the facility. Chain-of-custody begins here.",
//     specs: [
//       "Accepts all Li-ion battery form factors",
//       "Chemistries: LFP, NMC, NCA, LCO, LTO",
//       "Minimum batch: 100 kg | No maximum",
//       "EPR certificate triggered at intake",
//     ],
//   },
//   {
//     num: "02",
//     iconName: "bolt",
//     title: "Discharge to Zero",
//     tagline: "Thermal risk eliminated before handling.",
//     body: "Every battery pack — regardless of State of Charge — is fully discharged to zero volts in a controlled environment before any physical dismantling occurs. This step is non-negotiable. It eliminates the primary cause of battery fires during processing and ensures worker safety throughout the facility.",
//     specs: [
//       "Deep discharge: < 0.5V per cell",
//       "Brine immersion and resistive discharge methods",
//       "Real-time voltage and temperature monitoring",
//       "Isolates packs showing thermal stress",
//     ],
//   },
//   {
//     num: "03",
//     iconName: "wrench",
//     title: "Dismantling",
//     tagline: "Manual disassembly. Maximum material preservation.",
//     body: "Discharged packs are manually dismantled into their component modules and cells. We avoid automated cutting at this stage to preserve material integrity. Battery management systems (BMS), wiring harnesses, and casing materials are separated and channelled to appropriate recovery streams.",
//     specs: [
//       "Manual dismantling for precision separation",
//       "BMS and electronics recovered separately",
//       "Aluminium casings separated at source",
//       "Damaged or swollen cells isolated",
//     ],
//   },
//   {
//     num: "04",
//     iconName: "gear",
//     title: "Mechanical Shredding",
//     tagline: "Controlled fragmentation. Zero emissions.",
//     body: "Cells are shredded in a sealed, inert-atmosphere chamber to prevent electrolyte vapour escape and eliminate fire risk. The shredded output — called 'cell soup' — contains Black Mass, metallic foils, plastics, and separator material, which then proceed to the separation stage.",
//     specs: [
//       "Inert atmosphere shredding chamber",
//       "Electrolyte vapour capture and treatment",
//       "Particle size controlled for downstream separation",
//       "Continuous emission monitoring",
//     ],
//   },
//   {
//     num: "05",
//     iconName: "crystal",
//     title: "Separation & Black Mass",
//     tagline: "Material streams isolated. Value recovered.",
//     body: "The shredded mix is passed through a combination of thermal treatment (to remove residual electrolyte), sieving, magnetic separation (to remove ferrous materials), and air classification (to separate light plastics from dense metal foils). The result: isolated Black Mass, copper foil, aluminium foil, steel, and plastics.",
//     specs: [
//       "Black Mass purity: > 85% by weight",
//       "Copper foil recovered and baled",
//       "Aluminium foil separated and sold",
//       "Plastics sorted and recycled",
//     ],
//   },
//   {
//     num: "06",
//     iconName: "atom",
//     title: "Metal Recovery & Dispatch",
//     tagline: "Minerals back into the supply chain.",
//     body: "High-grade Black Mass is packaged and supplied to hydrometallurgical refiners who extract individual metals — lithium, cobalt, nickel, and manganese — for re-use in battery manufacturing. Copper, aluminium, and steel go to domestic smelters. Full traceability is maintained to the end buyer.",
//     specs: [
//       "Black Mass supplied to hydromet partners",
//       "Li, Co, Ni, Mn recovered for reuse",
//       "Cu, Al, Fe sold to domestic smelters",
//       "Material test certificates issued per batch",
//     ],
//   },
// ];

// function StepIcon({ name }) {
//   const size = 44;
//   if (name === "truck") return <TruckIcon size={size} />;
//   if (name === "bolt") return <BoltIcon size={size} />;
//   if (name === "wrench") return <WrenchIcon size={size} />;
//   if (name === "gear") return <GearIcon size={size} />;
//   if (name === "crystal") return <CrystalIcon size={size} />;
//   if (name === "atom") return <AtomIcon size={size} />;
//   return null;
// }

// function ProcessPage() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const reveals = document.querySelectorAll(".reveal");
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((e) => {
//         if (e.isIntersecting) { e.target.classList.add("visible"); observer.unobserve(e.target); }
//       });
//     }, { threshold: 0.1 });
//     reveals.forEach((r) => observer.observe(r));
//     return () => observer.disconnect();
//   }, []);

//   return (
//     <main style={{ paddingTop: "80px" }}>

//       {/* PAGE HERO */}
//       <section className="page-hero">
//         <div className="hero-grid-bg"></div>
//         <div className="hero-glow" style={{ opacity: 0.4 }}></div>
//         <div className="section-inner" style={{ position: "relative", zIndex: 2 }}>
//           <div className="section-tag">Our Process</div>
//           <h1 className="section-title display" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", marginBottom: "1.2rem" }}>
//             End-to-End. Transparent.<br />Fully Traceable.
//           </h1>
//           <p className="section-body" style={{ maxWidth: "620px" }}>
//             Six tightly controlled stages take a dead lithium-ion battery from collection to recovered minerals. Nothing leaves our custody unaccounted for.
//           </p>
//         </div>
//       </section>

//       {/* PROCESS STEPS */}
//       <section>
//         <div className="section-inner">
//           <div className="section-tag">Step by Step</div>
//           <h2 className="section-title display">The Full Process</h2>

//           <div className="process-deep reveal">
//             {steps.map((step, i) => (
//               <div className="pd-step" key={step.num}>
//                 <div className="pd-step-left">
//                   <div className="pd-num">{step.num}</div>
//                   <div className="pd-icon"><StepIcon name={step.iconName} /></div>
//                 </div>
//                 <div className="pd-step-right">
//                   <div className="pd-tagline">{step.tagline}</div>
//                   <h3>{step.title}</h3>
//                   <p>{step.body}</p>
//                   <ul className="pd-specs">
//                     {step.specs.map((s, j) => (
//                       <li key={j}>{s}</li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* SAFETY & COMPLIANCE */}
//       <section style={{ background: "var(--panel)" }}>
//         <div className="section-inner">
//           <div className="section-tag">Safety &amp; Compliance</div>
//           <h2 className="section-title display">Zero Compromises</h2>
//           <p className="section-body">
//             Every stage of our process is designed around safety first, material yield second.
//           </p>
//           <div className="safety-grid reveal">
//             <div className="usp-item">
//               <div className="usp-icon-wrap"><ShieldIcon size={22} /></div>
//               <div>
//                 <h3>Inert Atmosphere Processing</h3>
//                 <p>Shredding occurs in a sealed chamber with electrolyte vapour capture — eliminating fire and toxic exposure risk.</p>
//               </div>
//             </div>
//             <div className="usp-item">
//               <div className="usp-icon-wrap"><BoltIcon size={22} /></div>
//               <div>
//                 <h3>Pre-Processing Deep Discharge</h3>
//                 <p>No battery enters the shredder above 0.5V. We never skip this step, regardless of incoming battery condition.</p>
//               </div>
//             </div>
//             <div className="usp-item">
//               <div className="usp-icon-wrap"><GearIcon size={22} /></div>
//               <div>
//                 <h3>Continuous Monitoring</h3>
//                 <p>Temperature, voltage, and gas sensors are active throughout the facility. Any anomaly triggers an automatic shutdown protocol.</p>
//               </div>
//             </div>
//             <div className="usp-item">
//               <div className="usp-icon-wrap"><AtomIcon size={22} /></div>
//               <div>
//                 <h3>Effluent Treatment</h3>
//                 <p>All process liquids are treated on-site. Zero untreated discharge to drain or ground.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section style={{ borderTop: "var(--accent-line)" }}>
//         <div className="section-inner" style={{ textAlign: "center" }}>
//           <h2 className="section-title display">Want a Facility Walkthrough?</h2>
//           <p className="section-body" style={{ margin: "0 auto 2rem" }}>
//             We're open to site visits for serious partners. Get in touch to arrange one.
//           </p>
//           <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
//             <a href="/#contact" className="btn-primary">Request a Visit</a>
//             <Link to="/" className="btn-outline">← Back to Home</Link>
//           </div>
//         </div>
//       </section>

//     </main>
//   );
// }

// export default ProcessPage;



import { useEffect } from "react";
import { Link } from "react-router-dom";
import { TruckIcon, BoltIcon, WrenchIcon, GearIcon, CrystalIcon, AtomIcon, ShieldIcon } from "../Icons";

const steps = [
  {
    num: "01",
    iconName: "truck",
    title: "Collection & Intake",
    tagline: "Safe pickup. Full documentation. EPR triggered.",
    body: "Batteries are collected from OEM facilities, dealer networks, EV service centres, scrap aggregators, and solar/inverter installers across India. Every consignment is weighed, catalogued by chemistry (LFP, NMC, NCA, LCO, LTO) and condition, and issued an intake document before entering the facility. Chain-of-custody begins here and is maintained to the end buyer. Raw material feedstock rates: Mobile scrap ₹150/kg, Laptop scrap ₹230/kg, EV battery scrap at market rates.",
    specs: [
      "Accepts all Li-ion battery form factors: cylindrical, prismatic, pouch",
      "Chemistries: LFP, NMC, NCA, LCO, LTO, LMFP",
      "Minimum batch: 100 kg | No maximum volume",
      "EPR certificate triggered at intake — issued to source OEM",
      "Full chain-of-custody documentation from intake to output",
    ],
  },
  {
    num: "02",
    iconName: "bolt",
    title: "Safe Discharge to Zero Volts",
    tagline: "Thermal risk eliminated before any handling.",
    body: "Every battery pack — regardless of State of Charge — is fully discharged to zero volts in a controlled environment before any physical dismantling occurs. This step is non-negotiable. Internal short circuits in undischarged batteries can cause thermal runaway, fire, explosion, gas release (H₂, CO₂, CO, CH₄), or overheating. Safe crushing voltage is ≈2.5V per cell (SOC 0%). Deep discharge is achieved using static or dynamic resistive electronic loads providing constant current/voltage discharge — ensuring worker safety throughout the facility.",
    specs: [
      "Deep discharge to <0.5V per cell (target: SOC 0%, ≈2.5V safe crushing voltage)",
      "Methods: Brine immersion and resistive electronic load discharge",
      "Real-time voltage and temperature monitoring throughout",
      "Isolates packs showing thermal stress or physical damage before processing",
      "Gas monitoring: H₂, CO₂, CO, CH₄ detection active",
      "Fire detection and suppression standby during entire discharge phase",
    ],
  },
  {
    num: "03",
    iconName: "wrench",
    title: "Dismantling & Sorting",
    tagline: "Manual disassembly. Maximum material preservation.",
    body: "Discharged packs are manually dismantled into their component modules and cells using manual dismantling benches and robotic arms for large EV modules. We avoid automated cutting at this stage to preserve material integrity. Battery Management Systems (BMS), wiring harnesses, copper and aluminium current collectors, and casing materials are separated and channelled to appropriate recovery streams. Sorting identifies battery type, chemistry, and contaminants to ensure each stream receives appropriate downstream treatment.",
    specs: [
      "Manual dismantling for precision material separation",
      "Robotic dismantling arms for large EV battery modules",
      "BMS and electronics recovered separately for component reuse",
      "Aluminium and copper casings separated at source",
      "Damaged or swollen cells isolated for specialised handling",
      "Dust collection and safety enclosures throughout dismantling area",
    ],
  },
  {
    num: "04",
    iconName: "gear",
    title: "Mechanical Shredding",
    tagline: "Controlled fragmentation. Zero emissions.",
    body: "Cells are shredded using industrial shredders, hammer mills, and ball mills in a sealed, inert-atmosphere chamber to prevent electrolyte vapour escape and eliminate fire risk. The shredded output — called 'cell soup' — contains Black Mass, metallic foils, plastics, and separator material. Particle size is controlled for optimal downstream separation performance. Electrolyte vapour is captured and treated on-site. Continuous emission monitoring ensures zero untreated release.",
    specs: [
      "Industrial shredders + hammer mills for initial size reduction",
      "Ball mills / grinders for fine powdering of electrode materials",
      "Inert atmosphere shredding chamber — prevents electrolyte vapour escape",
      "Electrolyte vapour capture and on-site treatment system",
      "Particle size controlled for downstream separation efficiency",
      "Continuous emission monitoring — auto-shutdown protocol on anomaly",
      "Dust control and air filtration systems throughout",
    ],
  },
  {
    num: "05",
    iconName: "crystal",
    title: "Physical Separation & Black Mass",
    tagline: "Five material streams isolated. Full value recovered.",
    body: "The shredded mix passes through a multi-stage separation sequence: thermal treatment removes residual electrolyte; vibrating sieves and air classifiers separate by size and density; magnetic separators remove ferrous steel components; eddy current separators remove aluminium; air classification separates lightweight plastics from dense metal foils. The result: isolated Black Mass (>85% purity by weight), copper foil, aluminium foil, steel, and plastics — each packaged and sold to the appropriate downstream buyer.",
    specs: [
      "Thermal treatment: removes residual electrolyte from black mass",
      "Vibrating sieves: size-based separation to <2 micron black mass achievable",
      "Magnetic separators: removes all ferrous steel screws and casings",
      "Eddy current separators: recovers non-ferrous aluminium",
      "Air classifiers: separates light plastic from dense metal foils",
      "Black Mass purity: >85% by weight — premium hydromet-grade output",
      "Copper foil recovered, cleaned, and baled for smelter supply",
      "Aluminium foil separated and sold (₹200–250/kg market rate)",
      "Plastics sorted and channelled to recyclers",
    ],
  },
  {
    num: "06",
    iconName: "atom",
    title: "Metal Recovery & Dispatch",
    tagline: "Critical minerals back into the supply chain.",
    body: "High-grade Black Mass (₹500–600/kg) is packaged per batch with material test certificates and dispatched to hydrometallurgical refiners — including Attero Recycling, SungEel India, LOHUM Cleantech, and Exigo Recycling — who extract individual metals (lithium, cobalt, nickel, manganese) for reuse in battery manufacturing. Copper and aluminium go to domestic smelters. Iron/steel to domestic secondary steel. Full traceability is maintained to the end buyer. Material test certificates are issued per output batch.",
    specs: [
      "Black Mass: ₹500–600/kg, dispatched to registered hydromet refiners",
      "Confirmed buyers: Attero Recycling, SungEel India, LOHUM Cleantech, Exigo Recycling",
      "Metal recovery rates (NMC): Li 2.02%, Mn 17.3%, Ni 8.74%, Co 3.3%",
      "Copper foil: ₹650–850/kg, sold to domestic smelters",
      "Aluminium foil: ₹200–250/kg, sold to domestic aluminium processors",
      "Iron/steel: ₹25–35/kg, sold to secondary steel recyclers",
      "Material test certificates issued per output batch — CPCB-ready documentation",
    ],
  },
];

function StepIcon({ name }) {
  const size = 44;
  if (name === "truck") return <TruckIcon size={size} />;
  if (name === "bolt") return <BoltIcon size={size} />;
  if (name === "wrench") return <WrenchIcon size={size} />;
  if (name === "gear") return <GearIcon size={size} />;
  if (name === "crystal") return <CrystalIcon size={size} />;
  if (name === "atom") return <AtomIcon size={size} />;
  return null;
}

function ProcessPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const reveals = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("visible"); observer.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    reveals.forEach((r) => observer.observe(r));
    return () => observer.disconnect();
  }, []);

  return (
    <main style={{ paddingTop: "80px" }}>

      {/* PAGE HERO */}
      <section className="page-hero">
        <div className="hero-grid-bg"></div>
        <div className="hero-glow" style={{ opacity: 0.4 }}></div>
        <div className="section-inner" style={{ position: "relative", zIndex: 2 }}>
          <div className="section-tag">Our Process</div>
          <h1 className="section-title display" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", marginBottom: "1.2rem" }}>
            End-to-End. Transparent.<br />Fully Traceable.
          </h1>
          <p className="section-body" style={{ maxWidth: "680px" }}>
            Six tightly controlled stages take a dead lithium-ion battery from collection to recovered minerals. Mechanical and thermal treatment up to Black Mass stage, with hydrometallurgical refining via downstream partners. Nothing leaves our custody unaccounted for.
          </p>
        </div>
      </section>

      {/* PROCESS STEPS */}
      <section>
        <div className="section-inner">
          <div className="section-tag">Step by Step</div>
          <h2 className="section-title display">The Full Process</h2>

          <div className="process-deep reveal">
            {steps.map((step) => (
              <div className="pd-step" key={step.num}>
                <div className="pd-step-left">
                  <div className="pd-num">{step.num}</div>
                  <div className="pd-icon"><StepIcon name={step.iconName} /></div>
                </div>
                <div className="pd-step-right">
                  <div className="pd-tagline">{step.tagline}</div>
                  <h3>{step.title}</h3>
                  <p>{step.body}</p>
                  <ul className="pd-specs">
                    {step.specs.map((s, j) => (
                      <li key={j}>{s}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HYDROMET OVERVIEW */}
      <section style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">Future Phase — Hydrometallurgy</div>
          <h2 className="section-title display">Closing the Full Loop</h2>
          <p className="section-body">
            Our current facility produces premium Black Mass for hydrometallurgical partners. Our roadmap includes on-site hydromet capability — chemically dissolving metals from Black Mass into battery-grade salts ready for reuse.
          </p>
          <div className="safety-grid reveal" style={{ marginTop: "3rem" }}>
            <div className="usp-item">
              <div className="usp-icon-wrap"><AtomIcon size={22} /></div>
              <div>
                <h3>Leaching (Chemical Dissolution)</h3>
                <p>Black Mass is mixed with sulfuric acid (H₂SO₄) and hydrogen peroxide (H₂O₂) under controlled temperature and stirring, dissolving Li, Co, Ni, and Mn into a metal-rich leachate solution.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><CrystalIcon size={22} /></div>
              <div>
                <h3>Purification & Separation</h3>
                <p>Impurities are removed through precipitation and pH-controlled steps. Individual metals are separated using solvent extraction (SX) techniques — producing solutions enriched in each target metal.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><GearIcon size={22} /></div>
              <div>
                <h3>Metal Recovery & Crystallisation</h3>
                <p>Purified metal solutions are concentrated and crystallised into battery-grade salts: lithium carbonate (Li₂CO₃), cobalt sulphate (CoSO₄), nickel sulphate (NiSO₄), and manganese sulphate (MnSO₄).</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><ShieldIcon size={22} /></div>
              <div>
                <h3>Wastewater & Gas Treatment</h3>
                <p>All process liquids are treated on-site via a Zero Liquid Discharge (ZLD) ETP system before any disposal. Acid gases from leaching are scrubbed. Zero untreated discharge to drain or ground — meeting SPCB/CPCB norms.</p>
              </div>
            </div>
          </div>

          {/* <div className="compare-table reveal" style={{ marginTop: "3rem" }}>
            <div className="compare-header">
              <div>Battery Chemistry</div>
              <div className="compare-col-header">Li Recovery</div>
              <div className="compare-col-header">Co/Ni/Mn</div>
              <div className="compare-col-header alankaar">Black Mass Rate</div>
            </div>
            {[
              ["LMC (Lithium Manganese Cobalt)", "8.1%", "Mn 30.6%, Co 1.2%", "₹380/kg"],
              ["LCN (Lithium Cobalt Nickel)", "3.12%", "Co 6.02%, Ni 4.12%", "₹400/kg"],
              ["NMC (Nickel Manganese Cobalt)", "2.02%", "Mn 17.3%, Ni 8.74%, Co 3.3%", "₹480/kg"],
            ].map(([chem, li, other, rate]) => (
              <div className="compare-row" key={chem}>
                <div className="compare-label">{chem}</div>
                <div className="compare-val">{li}</div>
                <div className="compare-val">{other}</div>
                <div className="compare-val pos">{rate}</div>
              </div>
            ))}
          </div> */}
        </div>
      </section>

      {/* SAFETY & COMPLIANCE */}
      <section>
        <div className="section-inner">
          <div className="section-tag">Safety &amp; Compliance</div>
          <h2 className="section-title display">Zero Compromises</h2>
          <p className="section-body">
            Every stage of our process is designed around safety first, material yield second. Our facility meets all Hazardous Waste Management Rules requirements and SPCB/CPCB compliance standards.
          </p>
          <div className="safety-grid reveal">
            <div className="usp-item">
              <div className="usp-icon-wrap"><ShieldIcon size={22} /></div>
              <div>
                <h3>Inert Atmosphere Shredding</h3>
                <p>Shredding occurs in a sealed chamber with electrolyte vapour capture — eliminating fire, toxic gas exposure, and thermal runaway risk during the highest-risk processing stage.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><BoltIcon size={22} /></div>
              <div>
                <h3>Zero-Skip Deep Discharge</h3>
                <p>No battery enters the shredder above 0.5V — safe crushing voltage is ≈2.5V per cell. We never skip this step, regardless of incoming battery condition or claimed SOC.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><GearIcon size={22} /></div>
              <div>
                <h3>Continuous Sensor Monitoring</h3>
                <p>Temperature, voltage, and gas sensors (H₂, CO₂, CO, CH₄) are active throughout the facility at all times. Any anomaly triggers an automatic shutdown protocol — no manual intervention required.</p>
              </div>
            </div>
            <div className="usp-item">
              <div className="usp-icon-wrap"><AtomIcon size={22} /></div>
              <div>
                <h3>ZLD Effluent Treatment</h3>
                <p>All process liquids pass through the on-site Zero Liquid Discharge ETP before disposal. Zero untreated discharge to drain or ground — meeting SPCB Consent to Operate conditions.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* IMPLEMENTATION TIMELINE */}
      {/* <section style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">Project Timeline</div>
          <h2 className="section-title display">From Approval to Operations: ~18–24 Months</h2>
          <div className="timeline reveal">
            {[
              { year: "Phase 1 (10–11 mo)", event: "Licensing & Approvals", detail: "Project planning, feasibility study, site selection, EIA, Consent to Establish (SPCB), CPCB/Battery Waste Rules licence, fire safety, labour and building permits." },
              { year: "Phase 2 (6–7 mo)", event: "Plant Design & Construction", detail: "Detailed engineering design, procurement of machinery and equipment, civil construction of ~30,100 sq. ft. facility at ₹1,500/sq.ft. construction rate, machinery installation." },
              { year: "Phase 3 (3–4 mo)", event: "Plant Commissioning", detail: "Trial runs and process debugging, SPCB Consent to Operate, workforce hiring and safety training." },
              { year: "Month 20+", event: "Commercial Operations", detail: "Full commercial operations launch. Capacity ramp: 30% in Year 1, 60% Year 2, 90% Year 3, 100% from Year 4 onward." },
            ].map((t) => (
              <div className="timeline-item" key={t.year}>
                <div className="timeline-year">{t.year}</div>
                <div className="timeline-content">
                  <h4>{t.event}</h4>
                  <p>{t.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA */}
      <section style={{ borderTop: "var(--accent-line)" }}>
        <div className="section-inner" style={{ textAlign: "center" }}>
          <h2 className="section-title display">Want a Facility Walkthrough?</h2>
          <p className="section-body" style={{ margin: "0 auto 2rem" }}>
            We're open to site visits for serious partners. Get in touch to arrange one.
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <a href="/#contact" className="btn-primary">Request a Visit</a>
            <Link to="/" className="btn-outline">← Back to Home</Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default ProcessPage;